// widgets/RecentMoves.jsx
import React, { useEffect, useState } from 'react';
import { api } from '../scripts/api';
import { Truck, MapPin, Calendar } from 'lucide-react';
import '../App.css';
import './Widgets.css';

export default function RecentMoves() {
  const [moves, setMoves] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMoves = async () => {
      try {
        const { data } = await api.get('/moves'); // Uses /moves endpoint
        setMoves(data.slice(0, 5)); // Show recent 5
      } catch (e) {
        setError(e?.response?.data?.error || 'Failed to load moves');
      } finally {
        setLoading(false);
      }
    };
    fetchMoves();
  }, []);

  if (loading) return <div className="widget-loading">Loading moves...</div>;
  if (error) return <div className="widget-error">{error}</div>;

  return (
    <div className="widget recent-moves">
      <h3 className="widget-title">Recent Moves/Trips</h3>
      <ul className="moves-list">
        {moves.map((move) => (
          <li key={move.TripId} className="move-item">
            <Truck size={18} />
            <div>
              <div className="move-destination">
                <MapPin size={14} /> {move.destination || 'Unknown'}
              </div>
              <div className="move-details">
                <Calendar size={14} /> VIN: {move.chassis_vin || 'N/A'}
              </div>
              <div className="move-notes">{move.Notes?.slice(0, 50) || 'No notes'}...</div>
            </div>
          </li>
        ))}
        {moves.length === 0 && <li>No recent moves</li>}
      </ul>
    </div>
  );
}
